export const DEFAULT_EVENT_END_DATE_DATE = 1;
export const DEFAULT_EVENT_END_DATE_MONTH = 1;
export const DEFAULT_EVENT_END_DATE_YEAR = 2099;
export const DEFAULT_EVENT_END_DATE_TIME = new Date(2099, 1, 1).getTime();